<template>
  <div>
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
</div>  
</template>

<script>

import Footer from "@/layouts/Footer"
import Header from "@/layouts/user/Header"

export default {
  name: "MainUser",
  components: {
        Footer,
        Header,
    },
  mounted() {
    },
};
</script>



// WEBPACK FOOTER //
// src/layouts/user/MainUser.vue